










import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { WidgetMixin, FieldMixin, TextMixin, Validator } from "./mixins";

@Component
export default class WRadio extends Mixins(WidgetMixin, FieldMixin, TextMixin) {
  @Prop({ type: String, default: "" })
  value!: string;

  @Prop({ type: Boolean, default: false })
  required!: boolean;

  @Validator("required")
  requiredValidator(value: any) {
    return value !== null;
  }
}
